import React from 'react';
import styled from 'styled-components';
import Logo from './Logo';
import Icon from './buttons/ActionableIcon'

const DialogHeader = ({onClose}) => {

    const StyledDialogHeader = styled.div`
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        min-height: ${ props => props.theme.space[12] };
        border-bottom 1px solid ${ props => props.theme.palette.blueGrey[100]};
    `;

    const StyledHeader = styled.h2`
        width: 50%;  
    `;

    const StyledLogoWrapper = styled.div`

        margin: 0 ${props => props.theme.space[8]};
        
        & .stolo-logo {
          height: ${ props => props.theme.space[10] };
        }
    `;

    return (
        <StyledDialogHeader>
            <StyledLogoWrapper><Logo /></StyledLogoWrapper>
            <div>
                <Icon iconProps={{
                    name  : "icon-close",
                    width : "1rem",
                    height: "1rem",
                }} handleClick={onClose}/>
            </div>
        </StyledDialogHeader>
    );
};

export default DialogHeader;



// WEBPACK FOOTER //
// ./src/components/DialogHeader.js